import { Row, Col } from 'react-bootstrap';
import logo from 'assets/img/landing/logoEP.png';
import whatsappIcon from 'assets/img/landing/whatsapp-brands-solid.svg';
import mailIcon from 'assets/img/landing/mail.svg';
import mapIcon from 'assets/img/landing/ubicacion.svg';

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-8">
      <div className="container-small px-lg-7 px-xxl-3">
        <Row className="g-4 justify-content-between align-items-start">
          <Col xs={12} lg={4} className="mb-4 mb-lg-0">
            <img className="mb-3" src={logo} height="50" alt="Estudio Parkes" />
            <p className="text-light-emphasis opacity-75 fs-9">
              Asesoramiento profesional y personalizado. Defendiendo tus derechos laborales desde hace más de cinco décadas.
            </p>
          </Col>
          
          <Col xs={12} sm={6} lg={4}>
            <h5 className="text-white fw-bold mb-3">CONTACTO</h5>
            <div className="d-flex align-items-center gap-3 mb-3">
              <img src={whatsappIcon} alt="WhatsApp" width="20" />
              <div>
                <h6 className="mb-0 text-white-50 fs-10">WHATSAPP</h6>
                <p className="mb-0 fs-9 fw-semibold">1153069479</p>
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <img src={mailIcon} alt="Mail" width="20" />
              <div>
                <h6 className="mb-0 text-white-50 fs-10">EMAIL</h6>
                <p className="mb-0 fs-9 fw-semibold">jap@estudioparkes.com</p>
              </div>
            </div>
          </Col>

          <Col xs={12} sm={6} lg={4}>
            <h5 className="text-white fw-bold mb-3">UBICACIÓN</h5>
            <div className="d-flex align-items-start gap-3">
              <img src={mapIcon} alt="Ubicación" width="20" className="mt-1" />
              <div>
                <h6 className="mb-0 text-white-50 fs-10">Buenos Aires</h6>
                <p className="mb-0 fs-9 text-light-emphasis">
                  <a href="https://maps.app.goo.gl/TFNdEqVC3GL9KeK76" target="_blank" rel="noreferrer" className="text-white-50 text-decoration-none">
                    Piso 1, Oficina A, Mariano Boedo 375, Lomas de Zamora, Buenos Aires
                  </a>
                </p>
              </div>
            </div>
          </Col>
        </Row>
        
        <hr className="border-secondary my-5" />
        
        {/* Contenedor del Copyright y los Links Legales */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-white-50 fs-10">
          <p className="mb-2 mb-md-0">© {new Date().getFullYear()} Estudio Parkes. Todos los derechos reservados.</p>
          
          {/* Enlaces a las políticas para Meta */}
          <div className="d-flex gap-3">
            <a href="/privacidad.html" className="text-white-50 text-decoration-none text-hover-primary">
              Política de Privacidad
            </a>
            <a href="/datos.html" className="text-white-50 text-decoration-none text-hover-primary">
              Eliminación de Datos
            </a>
            <a href="/terminos.html" className="text-white-50 text-decoration-none text-hover-primary">
              Términos de Servicio
            </a>
          </div>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;